import { Exception } from "@studyportals/mb-platform-exceptions";
import { ErrorRequestHandler, NextFunction, RequestHandler, Response } from "express";
import { Request } from "express-serve-static-core";
import { inject, injectable } from "inversify";
import { IErrorReporter } from "../domain/interfaces/error-reporter.interface";
import { DI } from "../infrastructure/di";

@injectable()
export class ErrorMiddleware {

	@inject(DI.ERROR_REPORTER) private errorReporter: IErrorReporter;

	public getHandler(): ErrorRequestHandler {

		return (err: any, req: Request, res: Response, next: NextFunction) => {

			if (!err) {
				next();
			}

			if (err instanceof Error) {
				this.errorReporter.error(err, req);
			}

			if (err instanceof Exception) {
				this.errorReporter.error(err, err.cause!, req);
			}

			this.errorReporter.error("Error: " + err, req);
		};
	}
}
